/* eslint-disable no-console */
import axios from "@/plugins/axios";
import PendingRequests from "./PendingRequests.js";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  mixins: [PendingRequests],
  computed: {
    ...mapGetters("auth", ["token"]),
  },
  methods: {
    /*
     ** Wrapper to call useful API consummers, according to the params
     */
    async wrapperApi() {
      this.cancelPreviousRequests();
      this.resetCharts();
      await this.apiCalls();
      this.resetTrackers();
    },
    async apiCalls() {
      // Consummers according to params selected
      this.getGenderRepart();
      this.getAgeRepart();
      this.getDayOfWeekRepart("totalVisits");
      this.getDayOfWeekRepart("overnights");
      this.getDwellTimesRepart();
      this.GetCountriesPeriod(false);
      this.GetCountriesPeriod(true);
      this.GetCantonsPeriod(false);
      this.GetCantonsPeriod(true);
      this.GetMunicipalitiesPeriod(false);
      this.GetMunicipalitiesPeriod(true);
      this.GetPeriodManagersKPIs();
      this.GetHourlyVisitors();
    },
    apiCountriesCalls() {
      this.GetCountriesPeriod(true);
      this.GetCantonsPeriod(true);
      this.GetMunicipalitiesPeriod(true);
      this.GetCountriesPeriod(false);
      this.GetCantonsPeriod(false);
      this.GetMunicipalitiesPeriod(false);
    },
    /*
     ** Utils functions
     */
    resetCharts() {
      this.clearVariables();
    },
    /*
     ** API Consumers
     */

    // load latest period
    async latestMIPPeriod() {
      await axios
        .post(
          "mip/latestMIPPeriod",
          {
            territory_id: this.territory_id,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          let format = "MM-DD-yyyy";
          this.defaultValues.minDate = moment(res.data[0])
            .startOf("month")
            .add(1, "year")
            .format(format);
          this.defaultValues.maxDate = moment(res.data[1])
            .subtract(1, "months")
            .endOf("month")
            .format(format);
          this.defaultValues.period.start = moment(res.data[1])
            .subtract(1, "months")
            .startOf("month")
            .format(format);
          this.defaultValues.period.end = moment(res.data[1])
            .subtract(1, "months")
            .endOf("month")
            .format(format);
          this.defaultValues.monthRange = true;
        });
    },
    async getGenderRepart() {
      console.log(this.params.period[0], this.params.period[1]);
      axios
        .post(
          "mip/getGenderPeriod",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          var male_percent = (res.data.weights / res.data.values).toFixed(1);
          var female_percent = 100 - male_percent;

          // pass values to view
          this.indicators.female_percent = female_percent;
          this.indicators.male_percent = parseInt(male_percent);
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    async getAgeRepart() {
      axios
        .post(
          "mip/getAgeGroupsPeriod",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          // compute weighted percentages for visitors
          var group_19 = (res.data.weights_19 / res.data.values).toFixed(1);
          var group_39 = (res.data.weights_39 / res.data.values).toFixed(1);
          var group_64 = (res.data.weights_64 / res.data.values).toFixed(1);
          var group_older = (res.data.weights_older / res.data.values).toFixed(
            1
          );

          // send data to view
          this.indicators.ageGroups.series[0].data = [
            Number(group_19),
            Number(group_39),
            Number(group_64),
            Number(group_older),
          ];
          this.indicators.ageGroups.chartOptions.colors = this.chartColors;

          //this.$refs.ageGroups.refresh();
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    async getDayOfWeekRepart(indicator) {
      axios
        .post(
          "mip/getDayOfWeekPeriod",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          var actual = res.data.actual;
          var previous = res.data.previous ? res.data.previous : null;

          var weekdays = [
            this.$t("general.weekdays.sunday"),
            this.$t("general.weekdays.monday"),
            this.$t("general.weekdays.tuesday"),
            this.$t("general.weekdays.wednesday"),
            this.$t("general.weekdays.thursday"),
            this.$t("general.weekdays.friday"),
            this.$t("general.weekdays.saturday"),
          ];

          var data = new Array();
          var dataPrev = new Array();
          var labels = new Array();
          for (let i = 0; i < actual.length; i++) {
            switch (indicator) {
              case "totalVisits":
              default:
                data.push(Math.round(actual[i].total_visits));
                break;
              case "overnights":
                data.push(Math.round(actual[i].overnights));
                break;
              case "dayTrippers":
                data.push(Math.round(actual[i].day_trippers));
                break;
            }
            labels.push(weekdays[actual[i].day_of_week - 1]);
          }

          switch (indicator) {
            case "totalVisits":
              this.indicators.dayOfWeek.options.yaxis.title.text = this.$t(
                "indicators.totalVisitors"
              );
              this.indicators.dayOfWeek.data = [
                {
                  name: this.$t("indicators.totalVisitors"),
                  data: data,
                },
              ];
              this.indicators.dayOfWeek.options.xaxis.categories = labels;
              this.indicators.dayOfWeek.options.colors = this.chartColors;
              break;
            case "overnights":
              this.indicators.overnightsWeekday.options.yaxis.title.text = this.$t(
                "indicators.totalOvernights"
              );
              this.indicators.overnightsWeekday.data = [
                {
                  name: this.$t("indicators.totalOvernights"),
                  data: data,
                },
              ];
              this.indicators.overnightsWeekday.options.xaxis.categories = labels;
              this.indicators.overnightsWeekday.options.colors = this.chartColors;
              break;
          }

          if (previous) {
            for (let i = 0; i < previous.length; i++) {
              switch (indicator) {
                case "total_visits":
                default:
                  dataPrev.push(Math.round(previous[i].total_visits));
                  break;
                case "overnights":
                  dataPrev.push(Math.round(previous[i].overnights));
                  break;
                case "dayTrippers":
                  dataPrev.push(Math.round(previous[i].dayTrippers));
                  break;
              }
            }

            switch (indicator) {
              case "totalVisits":
                this.indicators.dayOfWeek.data = [
                  {
                    name: this.$t("indicators." + this.weekdayIndicator),
                    data: data,
                  },
                  {
                    name: this.$t("legends.previousYear"),
                    data: dataPrev,
                  },
                ];
                break;
              case "overnights":
                this.indicators.overnightsWeekday.data = [
                  {
                    name: this.$t("indicators.totalOvernights"),
                    data: data,
                  },
                  {
                    name: this.$t("legends.previousYear"),
                    data: dataPrev,
                  },
                ];
                break;
            }
          }
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    async getDwellTimesRepart() {
      axios
        .post(
          "mip/getDwellTimesPeriod",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          if (res.data.length > 0) {
            this.indicators.dwellTimes.data = [
              {
                name: this.$t("general.visitors"),
                data: [
                  res.data[0].mip_30m_1h,
                  res.data[0].mip_1h_2h,
                  res.data[0].mip_2h_3h,
                  res.data[0].mip_3h_4h,
                  res.data[0].mip_4h_5h,
                  res.data[0].mip_5h_6h,
                  res.data[0].mip_6h_7h,
                  res.data[0].mip_7h_8h,
                ],
              },
            ];
            this.indicators.dwellTimes.options.colors = this.chartColors;
          }
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    async GetCountriesPeriod(overnights) {
      axios
        .post(
          "mip/getCountriesPeriod",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            lang: this.$i18n.locale,
            filter_provenance: this.filter_country,
            overnights: overnights ? overnights : false,
            isEvent: false,
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .subtract(1, "year")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          var data = new Array();
          let field = overnights
            ? this.indicators.topCountriesOvernights
            : this.indicators.topCountries;
          if (res.data.length > 0) {
            if (Object.keys(res.data[0]).length > 5) {
              field.fields = [
                { key: "ranking", label: this.$t("general.ranking") },
                { key: "flag", label: "" },
                { key: "market", label: this.$t("general.originMarket") },
                { key: "visitors", label: this.$t("general.visitors") },
                {
                  key: "visitors_evo",
                  label: this.$t("general.previousYearShort"),
                },
                { key: "market_share", label: this.$t("general.marketShare") },
              ];

              for (let i = 0; i < res.data.length; i++) {
                data.push({
                  ranking: i + 1,
                  flag: res.data[i].country_iso_2,
                  market: res.data[i].country_name,
                  visitors: res.data[i].country_visits,
                  visitors_evo: res.data[i].previous_visits
                    ? res.data[i].country_visits / res.data[i].previous_visits -
                      1
                    : null,
                  market_share: res.data[i].market_share,
                });
              }
            } else {
              field.fields = [
                { key: "flag", label: "" },
                { key: "market", label: this.$t("general.originMarket") },
                { key: "visitors", label: this.$t("general.visitors") },
                { key: "market_share", label: this.$t("general.marketShare") },
              ];

              for (let i = 0; i < res.data.length; i++) {
                data.push({
                  flag: res.data[i].country_iso_2,
                  market: res.data[i].country_name,
                  visitors: res.data[i].country_visits,
                  market_share: res.data[i].market_share,
                });
              }
            }

            field.table = data;
          } else {
            field.fields = [
              { key: "information", label: this.$t("general.information") },
            ];
            field.table = [
              {
                information: this.$t(
                  "general.noDataDataProtectionMipCountries"
                ),
              },
            ];
          }
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    async GetCantonsPeriod(overnights) {
      axios
        .post(
          "mip/getCantonsPeriod",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            lang: this.$i18n.locale,
            filter_provenance: this.filter_canton,
            overnights: overnights ? overnights : false,
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .locale(this.$root.$i18n.locale)
              .subtract(1, "year")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .subtract(1, "year")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          let field = overnights
            ? this.indicators.topCantonsOvernights
            : this.indicators.topCantons;

          if (res.data.length > 0) {
            var data = new Array();
            if (Object.keys(res.data[0]).length > 5) {
              field.fields = [
                { key: "ranking", label: this.$t("general.ranking") },
                { key: "market", label: this.$t("general.canton") },
                { key: "visitors", label: this.$t("general.visitors") },
                {
                  key: "visitors_evo",
                  label: this.$t("general.previousYearShort"),
                },
                { key: "market_share", label: this.$t("general.marketShare") },
              ];

              for (let i = 0; i < res.data.length; i++) {
                data.push({
                  ranking: i + 1,
                  market: res.data[i].country_name,
                  visitors: res.data[i].country_visits,
                  visitors_evo: res.data[i].previous_visits
                    ? res.data[i].country_visits / res.data[i].previous_visits -
                      1
                    : null,
                  market_share: res.data[i].market_share,
                });
              }
            } else {
              field.fields = [
                { key: "ranking", label: this.$t("general.ranking") },
                { key: "market", label: this.$t("general.canton") },
                { key: "visitors", label: this.$t("general.visitors") },
                { key: "market_share", label: this.$t("general.marketShare") },
              ];

              for (let i = 0; i < res.data.length; i++) {
                data.push({
                  ranking: i + 1,
                  market: res.data[i].country_name,
                  visitors: res.data[i].country_visits,
                  market_share: res.data[i].market_share,
                });
              }
            }

            field.table = data;
          } else {
            field.fields = [
              { key: "information", label: this.$t("general.information") },
            ];
            field.table = [
              {
                information: this.$t("general.noDataDataProtectionMipCantons"),
              },
            ];
          }
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    async GetMunicipalitiesPeriod(overnights, isEvent) {
      axios
        .post(
          "mip/getMunicipalitiesPeriod",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            lang: this.$i18n.locale,
            filter_provenance: this.filter_canton,
            overnights: overnights ? overnights : false,
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .locale(this.$root.$i18n.locale)
              .subtract(1, "year")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .subtract(1, "year")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          var data = new Array();
          let field = overnights
            ? this.indicators.topMunicipalitiesOvernights
            : this.indicators.topMunicipalities;

          if (res.data.length > 0) {
            if (Object.keys(res.data[0]).length > 6) {
              field.fields = [
                { key: "ranking", label: this.$t("general.ranking") },
                { key: "town", label: this.$t("general.municipality") },
                { key: "canton", label: this.$t("general.canton") },
                { key: "district", label: this.$t("general.district") },
                { key: "visitors", label: this.$t("general.visitors") },
                {
                  key: "visitors_evo",
                  label: this.$t("general.previousYearShort"),
                },
                { key: "market_share", label: this.$t("general.marketShare") },
              ];

              for (let i = 0; i < res.data.length; i++) {
                data.push({
                  ranking: i + 1,
                  town: res.data[i].town_name,
                  canton: res.data[i].canton,
                  district: res.data[i].district,
                  visitors: res.data[i].town_visits,
                  visitors_evo: res.data[i].previous_visits
                    ? res.data[i].town_visits / res.data[i].previous_visits - 1
                    : null,
                  market_share: res.data[i].market_share,
                });
              }
            } else {
              field.fields = [
                { key: "ranking", label: this.$t("general.ranking") },
                { key: "town", label: this.$t("general.municipality") },
                { key: "canton", label: this.$t("general.canton") },
                { key: "district", label: this.$t("general.district") },
                { key: "visitors", label: this.$t("general.visitors") },
                { key: "market_share", label: this.$t("general.marketShare") },
              ];

              for (let i = 0; i < res.data.length; i++) {
                data.push({
                  ranking: i + 1,
                  town: res.data[i].town_name,
                  canton: res.data[i].canton,
                  district: res.data[i].district,
                  visitors: res.data[i].town_visits,
                  market_share: res.data[i].market_share,
                });
              }
            }
            field.table = data;
          } else {
            field.fields = [
              { key: "information", label: this.$t("general.information") },
            ];
            field.table = [
              {
                information: this.$t("general.noDataDataProtectionMipLocality"),
              },
            ];
          }
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    GetHourlyVisitors(event) {
      axios
        .post(
          "mip/GetHourlyVisitors",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          let graphData = new Array();
          let graphAxis = new Array();

          // add each element in arrays
          res.data.forEach((element) => {
            if (!event && element.hour < 6) {
              return;
            } else {
              graphData.push(element.visits);
              graphAxis.push(
                element.hour + " Uhr - " + (element.hour + 1) + " Uhr"
              );
            }
          });

          // pass arrays to chart
          this.indicators.hourlyVisitors.series[0].data = graphData;
          this.indicators.hourlyVisitors.chartOptions.xaxis.categories = graphAxis;
          this.indicators.hourlyVisitors.chartOptions.colors = this.chartColors;
        });
    },
    GetPeriodManagersKPIs() {
      axios
        .post(
          "mip/GetPeriodManagersKPIs",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            weekdays: this.params.weekdays ? this.params.weekdays : null,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          // compute total days
          let startDate = moment(this.params.period[0], "MM-DD-YYYY");
          let endDate = moment(this.params.period[1], "MM-DD-YYYY");
          let totalDays = endDate.diff(startDate, "days") + 1;

          // create table to store data
          let table = new Array();
          this.indicators.kpisTable.displayEvolution =
            res.data.visitorsChPrev != null ? true : false;

          // total overnights
          table.push({
            title: this.$t("indicators.totalOvernights"),
            value: res.data.totalOvernights,
            valuePrev: res.data.previousOvernights,
            evolution:
              res.data.previousOvernights != null
                ? res.data.totalOvernights / res.data.previousOvernights - 1
                : null,
            evolutionReal:
              res.data.previousOvernights != null
                ? res.data.totalOvernights - res.data.previousOvernights
                : null,
            share: res.data.totalOvernights / res.data.totalVisitors,
            dailyAverage: res.data.totalOvernights / totalDays,
          });
          this.indicators.kpis.overnights.value = res.data.totalOvernights;
          this.indicators.kpis.overnights.evo_real =
            res.data.totalOvernights - res.data.previousOvernights;
          this.indicators.kpis.overnights.evoPercent =
            res.data.previousOvernights != null
              ? res.data.totalOvernights / res.data.previousOvernights - 1
              : null;

          // swiss overnights
          table.push({
            title: this.$t("general.swiss"),
            value: res.data.overnightsCh,
            valuePrev: res.data.overnightsChPrev,
            evolution:
              res.data.overnightsChPrev != null
                ? res.data.overnightsCh / res.data.overnightsChPrev - 1
                : null,
            evolutionReal:
              res.data.overnightsChPrev != null
                ? res.data.overnightsCh - res.data.overnightsChPrev
                : null,
            display: "sub",
            share: res.data.overnightsCh / res.data.totalOvernights,
            dailyAverage: res.data.overnightsCh / totalDays,
          });

          // foreign overnights
          table.push({
            title: this.$t("general.foreigners"),
            value: res.data.overnightsEtr,
            valuePrev: res.data.overnightsEtrPrev,
            evolution:
              res.data.overnightsEtrPrev != null
                ? res.data.overnightsEtr / res.data.overnightsEtrPrev - 1
                : null,
            evolutionReal:
              res.data.overnightsEtrPrev != null
                ? res.data.overnightsEtr - res.data.overnightsEtrPrev
                : null,
            display: "sub",
            share: res.data.overnightsEtr / res.data.totalOvernights,
            dailyAverage: res.data.overnightsEtr / totalDays,
          });

          this.indicators.repartOvernights.data = [
            res.data.overnightsCh,
            res.data.overnightsEtr,
          ];

          // total day trippers
          table.push({
            title: this.$t("indicators.dayTrippers"),
            value: res.data.totalDayTrippers,
            valuePrev: res.data.totalDayTrippersPrev,
            evolution:
              res.data.totalDayTrippersPrev != null
                ? res.data.totalDayTrippers / res.data.totalDayTrippersPrev - 1
                : null,
            evolutionReal:
              res.data.totalDayTrippersPrev != null
                ? res.data.totalDayTrippers - res.data.totalDayTrippersPrev
                : null,
            share: res.data.totalDayTrippers / res.data.totalVisitors,
            dailyAverage: res.data.totalDayTrippers / totalDays,
          });
          this.indicators.kpis.dayTrippers.value = res.data.totalDayTrippers;
          this.indicators.kpis.dayTrippers.evo_real =
            res.data.totalDayTrippers - res.data.totalDayTrippersPrev;
          this.indicators.kpis.dayTrippers.evoPercent =
            res.data.totalDayTrippersPrev != null
              ? res.data.totalDayTrippers / res.data.totalDayTrippersPrev - 1
              : null;

          // day trippers CH
          table.push({
            title: this.$t("general.swiss"),
            value: res.data.DayTrippersCh,
            valuePrev: res.data.DayTrippersChPrev,
            evolution:
              res.data.DayTrippersChPrev != null
                ? res.data.DayTrippersCh / res.data.DayTrippersChPrev - 1
                : null,
            evolutionReal:
              res.data.DayTrippersChPrev != null
                ? res.data.DayTrippersCh - res.data.DayTrippersChPrev
                : null,
            display: "sub",
            share: res.data.DayTrippersCh / res.data.totalDayTrippers,
            dailyAverage: res.data.DayTrippersCh / totalDays,
          });

          // day trippers Etr
          table.push({
            title: this.$t("general.foreigners"),
            value: res.data.DayTrippersEtr,
            valuePrev: res.data.DayTrippersEtrPrev,
            evolution:
              res.data.DayTrippersEtrPrev != null
                ? res.data.DayTrippersEtr / res.data.DayTrippersEtrPrev - 1
                : null,
            evolutionReal:
              res.data.DayTrippersEtrPrev != null
                ? res.data.DayTrippersEtr - res.data.DayTrippersEtrPrev
                : null,
            display: "sub",
            share: res.data.DayTrippersEtr / res.data.totalDayTrippers,
            dailyAverage: res.data.DayTrippersEtr / totalDays,
          });

          // day trippers Etr
          table.push({
            title: this.$t("indicators.transitPeople"),
            value: res.data.transit,
            valuePrev: res.data.transitPrev,
            evolution:
              res.data.transitPrev != null
                ? res.data.transit / res.data.transitPrev - 1
                : null,
            evolutionReal:
              res.data.transitPrev != null
                ? res.data.transit - res.data.transitPrev
                : null,
            display: "sub",
            share: res.data.transit / res.data.totalDayTrippers,
            dailyAverage: res.data.transit / totalDays,
          });

          // total visitors
          table.push({
            title: this.$t("indicators.totalVisitors"),
            value: res.data.totalVisitors,
            valuePrev: res.data.previousVisitors,
            evolution:
              res.data.previousVisitors != null
                ? res.data.totalVisitors / res.data.previousVisitors - 1
                : null,
            evolutionReal:
              res.data.previousVisitors != null
                ? res.data.totalVisitors - res.data.previousVisitors
                : null,
            share: 1,
            dailyAverage: res.data.totalVisitors / totalDays,
          });
          this.indicators.kpis.totalVisitors.value = res.data.totalVisitors;
          this.indicators.kpis.totalVisitors.evo_real =
            res.data.totalVisitors - res.data.previousVisitors;
          this.indicators.kpis.totalVisitors.evoPercent =
            res.data.previousVisitors != null
              ? res.data.totalVisitors / res.data.previousVisitors - 1
              : null;

          // swiss visitors
          table.push({
            title: this.$t("general.swiss"),
            value: res.data.visitorsCh,
            valuePrev: res.data.visitorsChPrev,
            evolution:
              res.data.visitorsChPrev != null
                ? res.data.visitorsCh / res.data.visitorsChPrev - 1
                : null,
            evolutionReal:
              res.data.visitorsChPrev != null
                ? res.data.visitorsCh - res.data.visitorsChPrev
                : null,
            display: "sub",
            share: res.data.visitorsCh / res.data.totalVisitors,
            dailyAverage: res.data.visitorsCh / totalDays,
          });

          // foreign visitors
          table.push({
            title: this.$t("general.foreigners"),
            value: res.data.visitorsEtr,
            valuePrev: res.data.visitorsEtrPrev,
            evolution:
              res.data.visitorsEtrPrev != null
                ? res.data.visitorsEtr / res.data.visitorsEtrPrev - 1
                : null,
            evolutionReal:
              res.data.visitorsEtrPrev != null
                ? res.data.visitorsEtr - res.data.visitorsEtrPrev
                : null,
            display: "sub",
            share: res.data.visitorsEtr / res.data.totalVisitors,
            dailyAverage: res.data.visitorsEtr / totalDays,
          });

          this.indicators.visitorsRepart.data = [
            res.data.visitorsCh,
            res.data.visitorsEtr,
          ];

          // commuters
          table.push({
            title: this.$t("indicators.commuters"),
            value: res.data.totalCommuters,
            valuePrev: res.data.commutersPrev,
            evolution:
              res.data.commutersPrev != null
                ? res.data.totalCommuters / res.data.commutersPrev - 1
                : null,
            evolutionReal:
              res.data.commutersPrev != null
                ? res.data.totalCommuters - res.data.commutersPrev
                : null,
            dailyAverage: res.data.totalCommuters / totalDays,
          });

          // foreign workers
          table.push({
            title: this.$t("indicators.foreignWorkers"),
            value: res.data.totalForeignWorkers,
            valuePrev: res.data.foreignWorkersPrev,
            evolution:
              res.data.foreignWorkersPrev != null
                ? res.data.totalForeignWorkers / res.data.foreignWorkersPrev - 1
                : null,
            evolutionReal:
              res.data.foreignWorkersPrev != null
                ? res.data.totalForeignWorkers - res.data.foreignWorkersPrev
                : null,
            dailyAverage: res.data.totalForeignWorkers / totalDays,
          });

          // send data to vue
          this.indicators.kpisTable.items = table;
        });
    },
    async exportMipKPIs() {
      axios
        .post(
          "mip/ExportMipKPIs",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            lang: this.$i18n.locale,
          },
          {
            headers: { Authorization: `Bearer ${this.token}` },
            responseType: "blob",
          }
        )
        .then((response) => {
          const href = URL.createObjectURL(response.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", "MobilityInsightsKPIs.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        });
    },
    async exportMipProvenances() {
      axios
        .post(
          "mip/ExportMipProvenances",
          {
            territory_id: this.territory_id,
            date_start: moment(this.params.period[0], "MM-DD-YYYY").format(
              "MM-DD-YYYY"
            ),
            date_end: moment(this.params.period[1], "MM-DD-YYYY")
              .endOf("month")
              .format("MM-DD-YYYY"),
            comparison_start: moment(this.params.period[0], "MM-DD-YYYY")
              .subtract(1, "year")
              .startOf("month")
              .format("MM-DD-YYYY"),
            comparison_end: moment(this.params.period[1], "MM-DD-YYYY")
              .subtract(1, "year")
              .endOf("month")
              .add(1, "day")
              .format("MM-DD-YYYY"),
            lang: this.$i18n.locale,
          },
          {
            headers: { Authorization: `Bearer ${this.token}` },
            responseType: "blob",
          }
        )
        .then((response) => {
          const href = URL.createObjectURL(response.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", "MobilityInsightsProvenances.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        });
    },
    async loadJsonMap() {
      axios
        .post(
          "mip/GetTerritory",
          {
            territory_id: this.territory_id,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          this.map.geojson = res.data;
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
    async GetTerritoryName() {
      axios
        .post(
          "mip/GetTerritoryName",
          {
            territory_id: this.territory_id,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          this.territoryName = res.data;
        })
        .catch((err) => {
          if (err.message == "cancelled") {
            console.log("Request cancelled");
          } else {
            this.apiError = true;
          }
        });
    },
  },
};
